import { Component, OnInit } from '@angular/core';
import { Section } from 'src/app/core/models/DigitalKit';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-ux-ui',
  templateUrl: './ux-ui.component.html',
  styleUrls: ['./ux-ui.component.css'],
  standalone: false
})
export class UxUiComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | UX & UI Design');
  }

  sections: Section[] = [
    {
      title: 'RESEARCH ANALYSIS',
      description: 'Investigación Necesidades y objetivos del cliente Benchmarking Análisis del usuario',
      icon: 'assets/img/ux-1.png'
    },
    {
      title: 'CREATIVE PROCESS',
      description: 'Generación de ideas Brainstorming Iniciar dossier-guía del proyecto Concretar tareas Áreas de innovación',
      icon: 'assets/img/ux-2.png'
    },
    {
      title: 'USABILITY',
      description: 'Identificar mapa de viaje del usuario Usabilidad web y guías de usabiulidad Mapas UX',
      icon: 'assets/img/ux-3.png'
    },
    {
      title: 'PROTOTYPING',
      description: 'Diagramas digitales Wireframing Maquetación Sketching Pruebas de usuario',
      icon: 'assets/img/ux-4.png'
    },
    {
      title: 'INTERACTION DESIGN',
      description: 'Diseño interactivo de la maqueta Feedback del cliente Correctivos',
      icon: 'assets/img/ux-5.png'
    }
  ]

}
